import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { deleteBookMaster } from 'app/contexts/reducers/bookMaster/bookMasterSlice';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

export default function DeleteBookMasterDialog({
  open,
  onClose,
  deleteYearId,
  setApiCall,
  handleClickSuccess,
  handleClickError,
  setError,
  deleteYearName
}) {
  const dispatch = useDispatch();
  const currentDate = new Date();

  const [loading, setLoading] = useState(false);
  const handleDelete = async () => {
    try {
      const code = window.prompt('Please enter the code to delete the stock:');
      if (code === '3535') {
        if (deleteYearName !== currentDate.getFullYear()) {
          const response = await dispatch(deleteBookMaster({ deleteYearId }));
          if (!response.hasOwnProperty('error')) {
            onClose();
            setApiCall((prev) => !prev);

            handleClickSuccess('Prodcut delete successfully');
            setLoading(false);
          } else {
            throw response;
          }
        } else {
          handleClickError();
          setError({ payload: 'You Can Not Delete Current Year' });
          setLoading(false);
          onClose();
        }
      } else {
        window.alert('Incorrect code entered. Stock deletion canceled.');
      }
    } catch (e) {
      handleClickError();
      setError(e);
      setLoading(false);
    }
  };
  return (
    <Box>
      <Dialog
        open={open}
        onClose={onclose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>Year Delete Confirmation Dialog</DialogTitle>

        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to delete this Product? This action cannot be undone. Also this
            will remove all the data associated with this Year
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} color='primary'>
            Disagree
          </Button>

          <LoadingButton
            onClick={handleDelete}
            color='primary'
            loading={loading}
            variant='contained'
            sx={{ my: 2 }}
          >
            Delete Item
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
